import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { System } from './../../shared-components/System';
import { SpedCollection, DocumentFieldData, SpedDocumentAttachment } from './iep.model';

@Injectable({
  providedIn: 'root'
})
export class IepService {

  constructor(
    private http: HttpClient
  ) { }

  getSpedCollection(studentId: number, yearId: number, userId: number): Observable<SpedCollection[]> {
    let queryString = '';
    queryString += '?studentId=' + studentId +
      '&yearId=' + yearId +
      '&userId=' + userId;
    return this.http.get<SpedCollection[]>(System.apiURL.Student + 'GetSpedCollection' + queryString);
  }

  getSpedDocuments(studentId: number, collectionId: number, userId: number): Observable<DocumentFieldData[]> {
    let queryString = '';
    queryString += '?studentId=' + studentId +
      '&collectionId=' + collectionId +
      '&userId=' + userId;
    return this.http.get<DocumentFieldData[]>(System.apiURL.Student + 'GetSpedDocuments' + queryString);
  }

  getSpedDocumentAttachments(studentId: number, spedCollectionToStudentId: number, userId: number): Observable<SpedDocumentAttachment[]> {
    let queryString = '';
    queryString += '?studentId=' + studentId +
      '&spedCollectionToStudentId=' + spedCollectionToStudentId +
      '&userId=' + userId;
    return this.http.get<SpedDocumentAttachment[]>(System.apiURL.Student + 'GetSpedDocumentAttachments' + queryString);
  }

  viewCollectionDocument(spedCollectionId: number, studentId: number, spedCollectionToStudentId: number, collectionStatusId: number, templateVersionId: number, userId: number, siteId: number, yearId: number): Observable<string> {
    let queryString = '';
    queryString += '?spedCollectionId=' + spedCollectionId +
      '&studentId=' + studentId +
      '&spedCollectionToStudentId=' + spedCollectionToStudentId +
      '&collectionStatusId=' + collectionStatusId +
      '&templateVersionId=' + templateVersionId +
      '&userId=' + userId +
      '&siteId=' + siteId +
      '&yearId=' + yearId;
    return this.http.get<string>(System.apiURL.Student + 'ViewCollectionDocument' + queryString);
  }
}
